module.exports = __webpack_public_path__ + "img/bobac_bobocoin.gm.810d24e.png";